export const SOFASHIELD = 'Sofashield Plus';
export const SOFARESCUE_CODE = 'sofaRescue';

export const PULL_UP_ANILINE_CARE_KIT_NAME = 'Pull Up Aniline Care Kit';
export const BRUSHED_ANILINE_CARE_KIT_NAME = 'Brushed Aniline Care Kit';
export const LEATHER_CARE_KIT_NAME = 'Leather Care Kit';

export const FABRIC_CARE_KIT_NAME = 'Fabric Care kit';
export const FREE_FABRIC_CARE_KIT_NAME = 'Free Care Kit';

export const FABRIC_CARE_KIT_TYPE = 'Fabric';
export const LEATHER_CARE_KIT_TYPE = 'Leather';
export const CARE_KIT = 'Care Kit';

export enum UpsellTypes {
    Sofashield,
    LeatherCareKit,
    FabricCareKit,
    Sofaglide,
    SofaRescue
}